import React, { Component } from 'react'
import { CallInfoTheme } from 'modules/theme'
import { connect } from 'react-redux';
import { globalStateSelector } from 'store/selector';
import { globalAction, callAction, messageAction } from '../../../store/action';
import { CallPreviewLoading } from 'modules/theme';
global.__previewTimer = "";
export class CallInfo extends Component {
  constructor(props){
    super(props);
    this.rejectList = ["_id", "phone_number", "publicInfo", "updateBy", "update_at", "listId", "listName"]
    this.rejectedField = this.rejectedField.bind(this);
    this.sendMessage = this.sendMessage.bind(this);
    this.dialNumber = this.dialNumber.bind(this);
    this.skipFn = this.skipFn.bind(this);
  }
  rejectedField( custInfo ) {
    let validInfo = {};
    if( custInfo && custInfo.info ){
      for (const key in custInfo.info) {
        if (Object.hasOwnProperty.call(custInfo.info, key)) {
          const element = custInfo.info[key];
          if( this.rejectList.indexOf(key) == -1 ) {
            validInfo[key] = element;
          }
        }
      }
    }
    return validInfo;
  }
  sendMessage(type, message) {
    const { callProcess } = this.props;
    callProcess(type, message);
  }

  dialNumber() {
    let  {
      custInfo,
      previewTeam,
      isPreview,
      isCallback,
      dynamicUpdate,
      configProcessor
    } = this.props;
    previewTeam = previewTeam || {};
    if ( custInfo.info && custInfo.info.phone_number) {
      this.sendMessage('callInitiate', {
        phoneNumber: custInfo.info.phone_number,
        teamId : previewTeam.teamId,
        teamName : previewTeam.teamName,
        info : {
          leadset : {
            _id: previewTeam.leadsetId || "",
            name: previewTeam.leadsetName || ""
          },
          campaign : {
            _id: previewTeam.campaignId || "",
            name: previewTeam.campaignName || ""
          },
          callingMode : isCallback ? "callback" : "preview",
          custInfo : {
            ...custInfo.info
          }
        },
      });
      if( isCallback ){
        // configProcessor('schedule:delete', {
        //   "scedularId": callInfo.info && callInfo.info._id ? callInfo.info._id : ""
        // });
        dynamicUpdate({ key: 'cbTab', value: "" });
        dynamicUpdate({ key: 'cbNotify', value: false });
        dynamicUpdate({ key: 'cbInfo', value: "" });
      }
    } else {
      console.error(`[Click2Call] Number Not Found`, custInfo, previewTeam);
    }
  }
  doneFn() {
    console.log("doneFn .....");
  }
  skipFn() {
    const { 
      configProcessor,
      dynamicUpdate,
      emitSocketMessage,
      isCallback,
      isPreviewDial } = this.props;
    if( isCallback ){
      // send user online
      dynamicUpdate({ key: 'cbTab', value: "" });
      dynamicUpdate({ key: 'cbNotify', value: false });
      dynamicUpdate({ key: 'cbInfo', value: "" });
      let nextState =  isPreviewDial ? "preview" : "online";
      let message = {
        type: 'stateHandler',
        state: nextState,
        subState: '',
        stateInfo: ''
      };
      emitSocketMessage("message-processor", message)
    } else {
      clearTimeout(global.__previewTimer)
      global.__previewTimer = setTimeout(() => {
        configProcessor(`previewSkip`, {newLead : "yes"});
      }, 500);
      dynamicUpdate({"key":"isPreviewLoad",value : true });
      console.log("skipFn .....");
    }
  }
  render() {
    let  { custInfo, isPreview,isCallback, isPreviewLoad, previewTimer, previewStartTimer } = this.props;
    console.log("custInfo ----", custInfo, previewTimer, previewStartTimer );
    let title = "Info"; 
    custInfo = this.rejectedField( custInfo )
    isPreview = isPreview || false;
    isCallback = isCallback || false;
    if( isPreview && isPreviewLoad ) {
      return (<CallPreviewLoading 
        blankInfoImg={'/images/PreviewLead.png'}
        blankName={'Waiting for preview lead'}
        blankTime={'Loading Preview...'}
      />);  
    }
    if( isPreview ){
      title = "Preview"
    } else if  ( isCallback ){
      title = "Scheduled"
    }

    return (
      <CallInfoTheme
        previewTimer={previewTimer}
        previewStartTimer={previewStartTimer}
        doneFn={this.dialNumber}
        skipFn={this.skipFn}
        isPreview={isPreview}
        isCallback={isCallback}
        title={title}
        info={custInfo}
      />
    )
  }
}

const stateToProps = state => ({
  custInfo: globalStateSelector.getDynamic(state, { key: 'custInfo' }),
  isPreviewLoad: globalStateSelector.getDynamic(state, { key: 'isPreviewLoad' }),
  previewTimer: globalStateSelector.getDynamic(state, { key: 'previewTimer' }),
  isPreviewDial: globalStateSelector.getDynamic(state, { key: 'isPreviewDial' }),
  previewStartTimer: globalStateSelector.getDynamic(state, { key: 'previewStartTimer' }),
  previewTeam: globalStateSelector.getDynamic(state, { key: 'previewTeam' }),
});
 
const dispatchToProps = dispatch => ({
  dynamicUpdate: data => {
    dispatch(globalAction.dynamicUpdate({ data }));
  },
  callProcess: (type, messageData) => {
    dispatch(callAction.process(type, messageData));
  },
  configProcessor: (type, messageData) => {
    dispatch(messageAction.configProcessor(type, messageData));
  },
  emitSocketMessage: (type, messageData) => {
    dispatch(messageAction.emitSocketMessage(type, messageData));
  }
});
export default connect(stateToProps, dispatchToProps)(CallInfo);



// WEBPACK FOOTER //
// src/dialpad/components/layout/CallInfo.js